import { ViewModel } from "../../settings/viewModel";
import { PlotDefinition, ChartType } from "../../definitions";
import { DataProperty } from "../../library/constants";
import { HorizontalPlotter } from "./horizontalPlotter";

export class AbsoluteTablePlotter extends HorizontalPlotter {
    constructor(
        viewModel: ViewModel,
        width: number,
        height: number,
        reportArea: d3.Selection<SVGElement, any, any, any>,
        svg: d3.Selection<SVGElement, any, any, any>,
        locale: string
    ) {
        super(viewModel, width, height, reportArea, svg, locale);
    }

    protected getPlotDefinition(): PlotDefinition {
        let plotDefinition: PlotDefinition;
        plotDefinition = this.getBlankPlotDefinition(1);
        this.addAbsoluteDifferenceColumns(plotDefinition, ChartType.Table);
        return plotDefinition;
    }

    protected getDataProperty(): DataProperty {
        return DataProperty.AbsoluteDifference;
    }
}
